import React, {useState, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Grondaia from "./Grondaia";
import { setNumeroGrondaie } from '../../../Redux/UIMenus/uiOmbrelloniMenuSlice';
import { ombrelloniConfiguration } from '../../Utils/meshesConfiguration';
import { E_ConfOmbrelloniContrapposti, E_GenereOmbrellone, E_MainLato, E_MisureOmbrelloni, E_TipoOmbrellone } from '../../Utils/enumerations';

// Genera le grondaie tra gli ombrelloni
export default function Grondaie({indexLatoPrincipale, misuraPrincipale, misuraSecondaria}) {   
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const tipoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const misureOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misureOmbrellone);
    const misuraAutomaticaOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misuraOmbrelloneAutomatica);
    const isMisuraAutomaticaSelected = useSelector(state => state.uiOmbrelloniMenu.selezioneMisuraAutomatica);
    const tessutoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);
    const isMantovanaSelected = useSelector(state => state.uiOmbrelloniMenu.mantovana);
    const lunghezzaLato = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezzaLato = useSelector(state => state.uiMainMenu.larghezza);
    const isPedanaVisible = useSelector(state => state.uiPedanaMenu.isVisible);
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);   
    const isOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
    const ombrelloniContrappostiConf = useSelector(state => state.uiOmbrelloniMenu.confOmbrelloniContrapposti);
    
    const [grondaieArray, setGrondaieArray] = useState([]);     
    const mainLato = (indexLatoPrincipale === 1 || indexLatoPrincipale === 3) ? larghezzaLato : lunghezzaLato;
    const numbOfOmbrelloni = dataOmbrelloni.length;
    const realMisuraPrincipale = !isOmbrelloniContrapposti ? mainLato/numbOfOmbrelloni : mainLato/(numbOfOmbrelloni/2);     
    const ombrelloniDistance = !isMisuraAutomaticaSelected ? 
                                    !isOmbrelloniContrapposti ? 
                                        ((mainLato - (misuraPrincipale * numbOfOmbrelloni))/(numbOfOmbrelloni-1)) : 
                                        ((mainLato - (misuraPrincipale * (numbOfOmbrelloni/2))))/((numbOfOmbrelloni/2)-1) : 
                                0;
    const offsetOmbrelloniLarghezza = 0.2;
    const indexOmbrelloni = ombrelloniConfiguration.findIndex(element => element.meshSpecificName.toString() === tipoOmbrelloni.toString());
    const offsetLungLarghGrondaia = -0.2;

    let posY = !isMantovanaSelected ? ombrelloniConfiguration[indexOmbrelloni].grondaiaY : ombrelloniConfiguration[indexOmbrelloni].grondaiaYMantovana;
    if (isPedanaVisible)
        posY += altezzaPedana;

    const dispatch = useDispatch();

    // Calcola posizione, rotazione e scala di ogni grondaia
    const calculateGrondaie = () => {              
        // Genera le grondaie
        let tempGrondaieArray = [];     
        let rotation = [0,0,0];
        // Sceglie la rotazione corretta
        if (indexLatoPrincipale === 1 || indexLatoPrincipale === 3) {
            rotation = [Math.PI, Math.PI/2, 0];   
        } else if (indexLatoPrincipale === 2 || indexLatoPrincipale === 4) {
            rotation = [Math.PI, 0, 0];
        }        
        // Genera il numero in base agli ombrelloni
        for (let i=0; i<dataOmbrelloni.length-1; i++) {  
            if (isOmbrelloniContrapposti && i === numbOfOmbrelloni-2) continue; 
            let position = dataOmbrelloni[i].position;
            // Calcola le posizione
            let posX = 0;           
            let posZ = 0;
            switch(indexLatoPrincipale) {
                case 1: {     
                    posX = genereOmbrelloni.toString() !== E_GenereOmbrellone.Centrale.toString() ? (position[0] + ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato) : (-misuraSecondaria/2 - ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato);                    
                    if (isOmbrelloniContrapposti && i%2 !== 0)                       
                        posX = (position[0] - ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato) - dataOmbrelloni[0].secondaryDimension;
                    posZ = position[2] + (!isMisuraAutomaticaSelected ? (misuraPrincipale/2 + ombrelloniDistance/2) : (realMisuraPrincipale/2));                 
                }
                break;
                case 2: {
                    posX = position[0] + (!isMisuraAutomaticaSelected ? (misuraPrincipale/2 + ombrelloniDistance/2) : (realMisuraPrincipale/2));
                    posZ = genereOmbrelloni.toString() !== E_GenereOmbrellone.Centrale.toString() ? (position[2] + ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato + misuraSecondaria) : (misuraSecondaria/2 + ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato);
                    if (isOmbrelloniContrapposti && i%2 !== 0)                       
                        posZ = (position[2] - ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato);
                }
                break;
                case 3: {
                    posX = position[0] - ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato - misuraSecondaria;
                    if (isOmbrelloniContrapposti && i%2 !== 0)                       
                        posX = (position[0] + ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato);
                    posZ = position[2] + (!isMisuraAutomaticaSelected ? (misuraPrincipale/2 + ombrelloniDistance/2) : (realMisuraPrincipale/2));
                }
                break;
                case 4: {
                    posX = position[0] + (!isMisuraAutomaticaSelected ? (misuraPrincipale/2 + ombrelloniDistance/2) : (realMisuraPrincipale/2));
                    posZ = position[2] - ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato;
                    if (isOmbrelloniContrapposti && i%2 !== 0)                       
                        posZ = (position[2] + ombrelloniConfiguration[indexOmbrelloni].grondaiaOffsetLato) + dataOmbrelloni[0].secondaryDimension;
                }
                break;
            }   
            tempGrondaieArray.push({
                position: [posX, posY, posZ],
                rotation,    
            });
        }
        // Aggiorna l'array delle grondaie
        setGrondaieArray(tempGrondaieArray);
        dispatch(setNumeroGrondaie(tempGrondaieArray.length));
    }

    // Avvia il calcolo delle grondaie
    const generateGrondaie = () => {   
        // Resetta le grondaie ad ogni nuova generazione  
        resetGrondaie();       
        // Se non ci sono dati di ombrelloni, non calcolarle
        if (dataOmbrelloni.length === 0) {         
            return;
        }
        // Calcola le grondaie
        if (indexOmbrelloni >= 0 && tipoOmbrelloni.toString() !== E_TipoOmbrellone.Scegli.toString() && latoOmbrelloni.toString() !== E_MainLato.Scegli.toString() && misureOmbrelloni.toString() !== E_MisureOmbrelloni.Scegli.toString())
            calculateGrondaie();       
    }

    // Resetta l'array delle grondaie
    const resetGrondaie = () => {
        setGrondaieArray([]);
    }

    useEffect(() => {
      generateGrondaie();
    }, [isPedanaVisible, lunghezzaLato, larghezzaLato, altezzaPedana, genereOmbrelloni, tipoOmbrelloni, misureOmbrelloni, latoOmbrelloni, misuraAutomaticaOmbrelloni, isMisuraAutomaticaSelected, tessutoOmbrelloni, isMantovanaSelected, dataOmbrelloni, indexLatoPrincipale, misuraPrincipale, misuraSecondaria])    

    return (       
        grondaieArray.map((element, index) => (              
            <Grondaia key={`grondaia_standard_${element}_${index}`} position={element.position} rotation={element.rotation} larghezza={misuraSecondaria + offsetLungLarghGrondaia} lunghezza={isMisuraAutomaticaSelected ? offsetOmbrelloniLarghezza : ombrelloniDistance+offsetOmbrelloniLarghezza}/>
        ))  
    )
}
